import React from 'react';
import PropTypes from 'prop-types';
import { Col, Button, ShowAltIcon, Sheet } from '@paypalcorp/pp-react';
import CommonPreviewComponent from './CommonPreviewComponent';
import {
  isDonateButton,
  isTablet,
  isDonateLink,
  isHostedFlow,
} from '../../utils/buttonFactoryUtils';
import ButtonFactoryV3DesktopPreview from './ButtonFactoryV3DesktopPreview';
import WizardStep1Preview from './WizardStep1Preview';
function WizardMobilePreview({
  handleSubmit,
  openMobilePreview,
  isMobilePreviewOpen,
  closeMobilePreview,
  usePaypalButtonStyle,
  buttonSize,
  showAcceptedCardLogos,
  buttonImageUrl,
  onError,
  locale,
  country,
  steps: { currentStep, totalSteps },
  labels: { continueButton, finishButton, previewButton, previewTitle },
  showSpinner,
  buttonDropzoneSubmit,
  handleBannerAndLogoErrorCheck,
}) {
  function renderPreview() {
    const isMobile = !isTablet();
    if (currentStep === 1 && isDonateButton()) {
      return (
        <WizardStep1Preview
          usePaypalButtonStyle={usePaypalButtonStyle}
          buttonSize={buttonSize}
          showAcceptedCardLogos={!!showAcceptedCardLogos}
          buttonImageUrl={buttonImageUrl}
          onError={onError}
          locale={locale}
          country={country}
          isMobile={true}
        />
      );
    }
    return isMobile ? (
      <CommonPreviewComponent isMobile={isMobile} />
    ) : (
      <ButtonFactoryV3DesktopPreview />
    );
  }

  const handleButtonClick = () => {
    if (currentStep === 1) {
      if (isDonateLink()) {
        const res = handleBannerAndLogoErrorCheck();
        if (res) {
          handleSubmit();
        }
      } else {
        buttonDropzoneSubmit();
      }
    } else if (currentStep === 2 && isHostedFlow()) {
      const res = handleBannerAndLogoErrorCheck();
      if (res) {
        handleSubmit();
      }
    } else {
      handleSubmit();
    }
  };

  return (
    <>
      <Col lg="12" className="mobilePreview">
        <Button
          className="next"
          type="submit"
          onClick={handleButtonClick}
          btnState={showSpinner ? 'processing' : 'initial'}
        >
          {currentStep === totalSteps ? finishButton : continueButton}
        </Button>
        <Button
          tertiary
          className="button-link previewButton"
          onClick={openMobilePreview}
        >
          <ShowAltIcon />
          {previewButton}
        </Button>
      </Col>
      <Sheet
        isOpen={isMobilePreviewOpen}
        onClose={closeMobilePreview}
        title={previewTitle}
        divider
        mobileFixedHeight="90"
        className="mobilePreview darkBackground"
        wrapperClassName="mobilePreview-wrapper"
      >
        {renderPreview()}
      </Sheet>
    </>
  );
}

WizardMobilePreview.propTypes = {
  handleSubmit: PropTypes.func,
  openMobilePreview: PropTypes.func,
  isMobilePreviewOpen: PropTypes.bool,
  closeMobilePreview: PropTypes.func,
  steps: PropTypes.object,
  labels: PropTypes.object,
  usePaypalButtonStyle: PropTypes.bool,
  buttonSize: PropTypes.string,
  showAcceptedCardLogos: PropTypes.bool,
  buttonImageUrl: PropTypes.string,
  onError: PropTypes.func,
  locale: PropTypes.string,
  country: PropTypes.string,
  showSpinner: PropTypes.bool,
  buttonDropzoneSubmit: PropTypes.func,
  handleBannerAndLogoErrorCheck: PropTypes.func,
};

export default WizardMobilePreview;
